import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';
export const DataGridComponent: React.FC<DataGridProProps> = ({
  columns,
  rows,
  pageSize,
  rowsPerPageOptions,
  pagination,
  apiRef,
  components,
  initialState,
  columnVisibilityModel,
  // density,
  className,
  componentsProps,
  onPageSizeChange,
  onColumnVisibilityModelChange,
  onStateChange,
  onSelectionModelChange,
  disableSelectionOnClick,
  selectionModel,
  rowCount,
  page,
  onPageChange

}) => {
  return (
    <DataGridPro
      apiRef={apiRef}
      rows={rows}
      columns={columns}
      disableSelectionOnClick={disableSelectionOnClick}
      checkboxSelection
      onSelectionModelChange={onSelectionModelChange}
      page={page}
      onPageChange={onPageChange}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      rowsPerPageOptions={rowsPerPageOptions}
      checkboxSelectionVisibleOnly={true}
      pagination={pagination}
      disableColumnSelector={false}
      components={components}
      initialState={initialState}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={onColumnVisibilityModelChange}
      componentsProps={componentsProps}
      className={className}
      // density={density}
      onStateChange={onStateChange}
      selectionModel={selectionModel}
      rowCount={rowCount}
      paginationMode="server"
    />
  );
};
